import { defineStore } from 'pinia'
// import {ref} from 'vue'

export const authStore = defineStore('authStore', {
  state: () => ({
    user: {
      id:"",
      password: "",
      employee: {
        id:"",
        name: "",
        section: "",
        category: "",
        specialization:"",
        formalPersonalPhoto: ""
      }
    }

  })
})